'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'feather-pointed';
var width = 512;
var height = 512;
var aliases = ["feather-alt"];
var unicode = 'f56b';
var svgPathData = ['M87.3 352.3c3.7 13.8 12.1 26.3 23.2 38.3l234.9-234.8 11.3 11.3-56.9 56.9 149 0c5.1-14.4 9.8-29.1 14.1-43.9 17.4-60.6 27.2-120.6 31.8-162.3-41.7 4.6-101.7 14.4-162.2 31.8-71.1 20.5-140.6 50.7-183.2 93.3-75.2 75.2-75.4 159.4-61.9 209.3zm34.6 49.7c12.1 11.1 24.6 19.5 38.4 23.3 49.9 13.5 134.2 13.3 209.3-61.9 8.2-8.2 15.9-17.3 23.2-27.3l-204.9 0-66 65.9zm82-81.9l199.8 0c15.1-23.8 28.2-51.1 39.3-80l-159.1 0-80 80z', 'M512.5 0C505.6 83.7 472 283.5 380.8 374.6l-7.5 7.3c-73.1 68.1-153.7 72.6-206.7 61.3L156 440.7c-17.4-4.7-32.3-15.1-45.6-27.4L12 511.8 .7 500.5 99.2 401.9c-10.5-11.3-19.7-23.8-25.1-38.1l-2.4-7.3c-14.2-52.4-14-139.1 58.8-217.3l7.3-7.5C229 40.5 428.8 6.9 512.5 0zM187.8 336l-66 65.9c12.1 11.1 24.6 19.5 38.4 23.3 49.9 13.5 134.2 13.3 209.3-61.9 8.2-8.2 15.9-17.3 23.2-27.3l-204.9 0zM494.6 17.8c-41.7 4.6-101.7 14.4-162.2 31.8-71.1 20.5-140.6 50.7-183.2 93.3-75.2 75.2-75.4 159.4-61.9 209.3 3.7 13.8 12.1 26.3 23.2 38.3l234.9-234.8 11.3 11.3-56.9 56.9 149 0c5.1-14.4 9.8-29.1 14.1-43.9 17.4-60.6 27.2-120.6 31.8-162.3zM283.8 240l-80 80 199.8 0c15.1-23.8 28.2-51.1 39.3-80l-159.1 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFeatherPointed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;